export default "__VITE_ASSET__Dt8hS9aK__"